import { InfoAnalyticTypeEnum } from "../enums";
import { BaseFilterModel } from "./baseFilter.model";

export class InfoAnalyticFilter extends BaseFilterModel {
  analyticType: InfoAnalyticTypeEnum;
}